import { render } from "./SubAgents.vue?vue&type=template&id=75d03a48&ts=true"
import script from "./SubAgents.vue?vue&type=script&lang=ts"
export * from "./SubAgents.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__